import { render, staticRenderFns } from "./viewbill.vue?vue&type=template&id=0565afa7&scoped=true&"
import script from "./viewbill.vue?vue&type=script&lang=js&"
export * from "./viewbill.vue?vue&type=script&lang=js&"
import style0 from "./viewbill.vue?vue&type=style&index=0&id=0565afa7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0565afa7",
  null
  
)

export default component.exports